import atlasLogo from "@/assets/icons/atlasLogo.svg";
import { cn } from "@/lib/utils";

import { Avatar, AvatarImage } from "./ui/avatar";

interface AtlasLogoProps {
  altText: string;
  className?: string;
}

const AtlasLogo = ({ altText, className }: AtlasLogoProps) => {
  const themedStylesAvatar = "flex flex-wrap justify-widget-logo";
  const themedStylesAvatarImg = "h-(--height-widget-logo) w-auto";

  return (
    <div className={cn(themedStylesAvatar, className)}>
      <Avatar className="size-auto rounded-none">
        <AvatarImage
          src={atlasLogo}
          alt={altText}
          className={cn(themedStylesAvatarImg)}
          loading="eager"
          decoding="async"
          fetchPriority="high"
        />
      </Avatar>
    </div>
  );
};

export default AtlasLogo;
